import React from 'react';
import PropTypes from 'prop-types';

import moment from 'moment';

import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';

import RaisedButton from 'material-ui/FlatButton';
import CircularProgress from 'material-ui/CircularProgress';
import MediaQuery from 'react-responsive';
import { List, ListItem } from 'material-ui/List';

const tableState = {
    fixedHeader: true,
    fixedFooter: true,
    stripedRows: false,
    showRowHover: false,
    selectable: true,
    multiSelectable: true,
    enableSelectAll: true,
    deselectOnClickaway: false,
    height: '500px',
};

class SubscriptionsTable extends React.Component {
    static propTypes = {
        actions: PropTypes.object,
        receipts: PropTypes.object,
        selectedReceipts: PropTypes.object,
        selectionEnabled: PropTypes.bool,
        isFetching: PropTypes.bool,
        onRowSelection: PropTypes.func,
        uncoupleSubscriptions: PropTypes.func,
    };

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedRows: [],
        };
    }
    // this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

    handleTouchTap = event => {
        // This prevents ghost click.
        event.preventDefault();

        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    longDateFormat(date) {
        if (date) {
            return moment(date).format('DD.MM.YY');
        } else {
            return 'Nicht aktiviert';
        }
    }

    dateFromString(string) {
        return moment(string);
    }

    formatDate(date) {
        return moment(date).format('DD.MM.YYYY');
    }

    _handleButtonTap(e, c) {
        e.preventDefault();
        e.stopPropagation();
    }

    nameForRenawal = type => {
        switch (type) {
            case 'monthly':
                return 'monatlich';
            default:
                return 'n/a';
        }
    };

    nameForDeviceID = id => {
        if (id !== null) {
            return id;
        } else {
            return 'noch frei';
        }
    };

    cancelSubscription = subscription => {
        this.setState({ open: false });
        this.props.cancelSubscription({ id: subscription.get('id') });
    };

    onRowSelection = selectedRows => {
        this.setState({ selectedRows });
    };

    uncoupleSubscriptions = event => {
        const ids = this.state.selectedRows.map(row => this.props.subscriptions.getIn([row, 'id']));
        // console.log(ids)
        this.props.uncoupleSubscriptions(ids);
        this.setState({ selectedRows: [] });
    };

    render = () => {
        // console.log('subscription')
        const subscriptionNodes = this.props.subscriptions.map((subscription, i) => {
            return (
                <TableRow
                    key={subscription.get('id')}
                    selectable
                    selected={this.state.selectedRows.indexOf(i) !== -1}>
                    <TableRowColumn>{subscription.get('activationDateString')}</TableRowColumn>
                    <TableRowColumn>
                        <div>{subscription.get('activationCode')}</div>
                    </TableRowColumn>
                    <TableRowColumn>
                        <div>{subscription.get('email')}</div>
                    </TableRowColumn>
                    <TableRowColumn>
                        {subscription.get('startDateString')}
                        <br />
                        {subscription.get('endDateString') || '-'}
                    </TableRowColumn>
                    <TableRowColumn>
                        {this.nameForDeviceID(subscription.get('device_id'))}
                        <br />
                        {subscription.get('activationDeviceId')}
                        <br />
                        {subscription.get('activationOs')}
                        <br />
                        <br />
                        {subscription.get('subscriptionName')}
                    </TableRowColumn>
                </TableRow>
            );
        });

        const mobileNodes = this.props.subscriptions.map(subscription => {
            return (
                <ListItem
                    key={subscription.get('id')}
                    primaryText={<h2>{subscription.get('activationCode')}</h2>}
                    secondaryText={
                        <span>
                            <strong>Lizenz für</strong> {subscription.get('email')} <br />{' '}
                            <strong>Aktiviert am</strong>{' '}
                            {this.longDateFormat(subscription.get('activationDateString'))} <br />{' '}
                            <strong>Geräte-ID</strong>{' '}
                            {this.nameForDeviceID(subscription.get('activationDeviceId'))}
                        </span>
                    }
                />
            );
        });

        const { isFetching } = this.props;

        return (
            <div>
                <RaisedButton
                    label="Entkoppeln"
                    secondary
                    onClick={this.uncoupleSubscriptions}
                    disabled={this.state.selectedRows.length < 1}
                />
                <MediaQuery query="(min-width: 830px)">
                    <Table
                        height={tableState.height}
                        fixedHeader={tableState.fixedHeader}
                        fixedFooter={tableState.fixedFooter}
                        selectable={tableState.selectable}
                        multiSelectable={tableState.multiSelectable}
                        onRowSelection={this.onRowSelection}>
                        <TableHeader
                            enableSelectAll={tableState.enableSelectAll}
                            displaySelectAll
                            adjustForCheckbox={false}>
                            {isFetching && (
                                <TableRow>
                                    <TableHeaderColumn
                                        colSpan="6"
                                        tooltip="Super Header"
                                        style={{
                                            textAlign: 'center',
                                        }}>
                                        <div
                                            className="progress-indicator-wrapper"
                                            style={{
                                                padding: '5px',
                                            }}>
                                            <CircularProgress mode="indeterminate" size={0.5} />
                                        </div>
                                    </TableHeaderColumn>
                                </TableRow>
                            )}
                            <TableRow>
                                <TableHeaderColumn tooltip="Datum Aktivierung">
                                    Datum Aktivierung
                                </TableHeaderColumn>
                                <TableHeaderColumn tooltip="Aktivierungscode">
                                    Aktivierungscode
                                </TableHeaderColumn>
                                <TableHeaderColumn tooltip="Mailempfänger">
                                    Mailempfänger
                                </TableHeaderColumn>
                                <TableHeaderColumn tooltip="Gültigkeit">
                                    Gültigkeit
                                    <br />
                                    Von
                                    <br />
                                    Bis
                                </TableHeaderColumn>
                                <TableHeaderColumn tooltip="Geräte-ID">
                                    Geräte-ID
                                    <br />
                                    Gerätename
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody
                            deselectOnClickaway={tableState.deselectOnClickaway}
                            displayRowCheckbox>
                            {subscriptionNodes}
                        </TableBody>
                    </Table>
                </MediaQuery>
                <MediaQuery query="(max-width: 830px)">
                    <div
                        style={{
                            paddingLeft: '20px',
                            paddingRight: '20px',
                        }}>
                        <List>{mobileNodes}</List>
                    </div>
                </MediaQuery>
            </div>
        );
    };
}
export default SubscriptionsTable;
